import { ServiceApi } from '../../utils/auth'

const state = {
  user: null,
  loading: false,
  error: null,
  referred: [],
}

const actions = {
  async login({ commit, dispatch }, payload) {
    try {
      commit('loginBegin')
      await ServiceApi.getCookie();
      const response = await ServiceApi.post('api/login', payload)
      commit('loginSuccess', true)
      await dispatch('fetchUser')
      return response
    } catch (err) {
      commit('loginErr', err)
    }
  },

  async register({ commit }, payload) {
    try {
      commit('loginBegin')
      const response = await ServiceApi.post('/api/register', payload)
      commit('loginSuccess', true)
      return response
    } catch (err) {
      commit('loginErr', err)
    }
  },

  async fetchUser({ commit, dispatch }) {
    try {
      const data = (await ServiceApi.get('api/user')).data
      commit('setUser', data.data)
      return data
    } catch (error) {
      commit('setUser', null)
      return error
    }
  },

  async logout({ commit }) {
    commit("config/SET_OVERLAY", true, { root: true });
    try {
      commit('logoutBegin')
      await ServiceApi.getCookie();
      const data = await ServiceApi.post('api/logout')
      commit('setUser', null)
      commit('logoutSuccess', null)
      return data
    } catch (err) {
      commit('logoutErr', err)
    }finally{
      commit("config/SET_OVERLAY", false, { root: true });
    }
  },

  async forgotPassword({ commit }, payload) {
    try {
      commit('logoutBegin')
      const resp = await ServiceApi.post('api/forgot-password', payload)
      commit('loginSuccess', true)
      return resp
    } catch (error) {
      commit('logoutErr', error)
      return error
    }
  },
  async restorePassword({ commit }, payload) {
    try {
      commit('logoutBegin')
      const resp = await ServiceApi.post('api/reset-password', payload)
      commit('loginSuccess', true)
      return resp
    } catch (error) {
      commit('logoutErr', error)
      return error
    }
  },


  // PROFILE CURRENT USER
  async updateProfile({ commit, dispatch }, payload) {
    try {
      commit('loginBegin')
      const response = await ServiceApi.post('/api/update-user', payload)
      await dispatch('fetchUser')
      commit('loginSuccess', true)
      return response
    } catch (err) {
      commit('loginErr', err)
    }
  },

  async updatePassword({ commit, dispatch }, payload) {
    try {
      commit('loginBegin')
      const response = await ServiceApi.put('/api/updatePassword', payload)
      await dispatch('fetchUser')
      commit('loginSuccess', true)
      return response
    } catch (err) {
      commit('loginErr', err)
    }
  },

  async updateLang({ commit, dispatch }, payload) {
    try {
      commit('loginBegin')
      const response = await ServiceApi.put(`/api/change-lang`, payload)
      await dispatch('fetchUser')
      commit('loginSuccess', true)
      return response
    } catch (err) {
      commit('loginErr', err)
    }
  },

  // My Referals
  async myReferred({ commit, dispatch }, payload) {
    try {
      commit('loginBegin')
      const response = await ServiceApi.get(`/api/my-referred-users`, payload)
      commit('SET_REFERRED', response.data)
      commit('loginSuccess', true)
      return response
    } catch (err) {
      commit('loginErr', err)
    }
  },

  async referenLink({ commit, dispatch }, id) {
    commit('loginBegin')
    try {
      const data = await ServiceApi.get(`/api/referrer/${id}/get-link`)
      commit('loginSuccess', true)
      return data.data.data.referrer_link
    } catch (err) {
      commit('loginErr', err)
    }
  },
}

const getters = {
  user: (state) => state.user,
  check: (state) => state.user !== null && state.user !== undefined,
  getReferred: (state) => state.referred,
  isLoading: (state) => state.loading,
}

const mutations = {
  setUser(state, user) {
    state.user = user
  },
  SET_REFERRED(state, payload){
    state.referred = payload.data
  },
  loginBegin(state) {
    state.loading = true
  },
  loginSuccess(state) {
    state.loading = false
  },
  loginErr(state, err) {
    state.loading = false
    state.error = err
  },
  logoutBegin(state) {
    state.loading = true
  },
  logoutSuccess(state) {
    state.loading = false
  },
  logoutErr(state, err) {
    state.loading = false
    state.error = err
  }
}

export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters
}
